module.exports = __webpack_public_path__ + "static/media/officePreview.9cecc861.png";